import React from 'react';
import userpic from '@iso/assets/images/logop7_nfund.png';

export default function ({ maxVHHeight }) {
    return <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'100%'}}>
        <img alt="Logo" src={userpic} style={{ maxWidth: '90%', maxHeight: maxVHHeight }} />
    </div>
}